<app-pie-chart [dataTable]="chartData" [chartOptions]="chartOptions">
  <div centerContainer>
    <div class="chart-value">{{ usedPercentage | number : '1.0-0' }}%</div>
    <div class="mt-2">
      DI N
      <sup>o</sup>
      {{ status.widgetData.total }}
    </div>
  </div>
</app-pie-chart>
